import { ValidUtils } from "../valid/ValidUtils.js";
import { isDefined } from "../types.js";
import { ObjectPathParser } from "../parser/path/ObjectPathParser.js";
var ObjectUtils;
(function(ObjectUtils2) {
  ObjectUtils2.constructorName = (target) => {
    if (target && target.constructor && target.constructor.name) {
      return target.constructor.name;
    } else if (target && target.name) {
      return target.name;
    }
  };
  ObjectUtils2.deepCopy = (obj) => {
    if (obj instanceof Map) {
      return new Map(JSON.parse(JSON.stringify(Array.from(obj.entries()))));
    } else if (obj instanceof Set) {
      return new Set(JSON.parse(JSON.stringify(Array.from(obj.values()))));
    } else if (ValidUtils.isNullOrUndefined(obj)) {
      return obj;
    }
    return JSON.parse(JSON.stringify(obj));
  };
  ObjectUtils2.allProtoTypeName = (target, filter) => {
    let data = [];
    if (target) {
      const proto = Object.getPrototypeOf(target);
      if (proto && (data = Object.keys(proto) || []).length > 0) {
        data = data.concat(ObjectUtils2.allProtoTypeName(proto, filter));
      }
    }
    let result = data.filter((it) => it !== "constructor");
    if (filter && target) {
      const proto = Object.getPrototypeOf(target);
      result = result.filter((key) => filter(key, proto?.[key]));
    }
    return result;
  };
  ObjectUtils2.uniqueKeys = (obj) => {
    const allKeys = Array.from(new Set((Array.isArray(obj) ? obj : [obj]).flatMap((item) => Object.keys(item))));
    return allKeys;
  };
  ObjectUtils2.ownPropertyNames = (target) => {
    const data = [];
    if (target) {
      if (!target.prototype) {
        const a = Object.getPrototypeOf(target);
        data.push(...Object.getOwnPropertyNames(a));
      } else {
        data.push(...Object.getOwnPropertyNames(Object.getPrototypeOf(target)));
      }
    }
    return data.filter((it) => it !== "constructor");
  };
  ObjectUtils2.protoTypeName = (target) => {
    let data = [];
    if (target) {
      const proto = Object.getPrototypeOf(target);
      data = Object.keys(proto) || [];
    }
    return data.filter((it) => it !== "constructor");
  };
  ObjectUtils2.protoTypes = (target) => {
    const data = [];
    if (target) {
      const proto = Object.getPrototypeOf(target);
      (Object.keys(proto) || []).filter((it) => it !== "constructor").forEach((it) => {
        data.push(proto[it]);
      });
    }
    return data;
  };
  ObjectUtils2.seal = (target) => {
    return Object.seal(target);
  };
  ObjectUtils2.isPrototypeOfTarget = (start, target) => {
    if (start && target) {
      return Object.prototype.isPrototypeOf.call(start.prototype, target);
    } else {
      return false;
    }
  };
  ObjectUtils2.prototypeOfDepth = (target, dest) => {
    let object = target;
    const r = [];
    if (dest) {
      do {
        object = Object.getPrototypeOf(object);
        if (object?.constructor === dest) {
          break;
        }
        r.push(object);
      } while (object);
    }
    return r;
  };
  ObjectUtils2.allProtoType = (start) => {
    const depth = (target, bowl = []) => {
      if (target.prototype) {
        bowl.push(target);
        depth(Object.getPrototypeOf(target), bowl);
      }
      return bowl;
    };
    const d = depth(start);
    return d;
  };
  ObjectUtils2.prototypeOf = (start) => {
    return Object.getPrototypeOf(start);
  };
  ObjectUtils2.prototypeKeyMap = (target) => {
    const data = /* @__PURE__ */ new Map();
    if (target) {
      const proto = Object.getPrototypeOf(target);
      (Object.keys(proto) || []).filter((it) => it !== "constructor").forEach((it) => {
        data.set(proto[it], it);
      });
    }
    return data;
  };
  ObjectUtils2.prototypeName = (target, fnc) => {
    return ObjectUtils2.prototypeKeyMap(target).get(fnc);
  };
  ObjectUtils2.pickRandomKey = (target) => {
    const keys = Object.keys(target);
    return keys[Math.floor(Math.random() * keys.length)];
  };
  ObjectUtils2.pickRandomValue = (target) => {
    const keys = Object.keys(target);
    return target[keys[Math.floor(Math.random() * keys.length)]];
  };
  ObjectUtils2.pickRandomKeyValue = (target) => {
    const keys = Object.keys(target);
    const key = keys[Math.floor(Math.random() * keys.length)];
    return { key, value: target[key] };
  };
  ObjectUtils2.keyValues = (target) => {
    const keys = Object.keys(target);
    return keys.map((key) => ({ key, value: target[key] }));
  };
  ObjectUtils2.entries = (target) => {
    return Object.entries(target);
  };
  ObjectUtils2.values = (target) => {
    return Object.values(target);
  };
  ObjectUtils2.keys = (target) => {
    return Object.keys(target);
  };
  ObjectUtils2.keyLength = (target) => {
    return ObjectUtils2.keys(target).length;
  };
  ObjectUtils2.toDeleteUndefinedAndNull = (target, config) => {
    const cleanValue = (value) => {
      if (Array.isArray(value)) {
        return value.filter((item) => item !== void 0 && item !== null).map(cleanValue);
      } else if (value && typeof value === "object") {
        if (config?.deep) {
          return Object.fromEntries(Object.entries(value).filter(([_, v]) => v !== void 0 && v !== null).map(([k, v]) => [k, cleanValue(v)]));
        } else {
          return Object.fromEntries(Object.entries(value).filter(([_, v]) => v !== void 0 && v !== null));
        }
      }
      return value;
    };
    return cleanValue(target);
  };
  let Path;
  (function(Path2) {
    Path2.isFunctionScript = (script) => {
      return ObjectPathParser.isFunctionScript(script);
    };
    Path2.isArrowFunctionScript = (script) => {
      return ObjectPathParser.isArrowFunctionScript(script);
    };
    Path2.toOptionalChainPath = (path) => {
      if (!path) {
        return "";
      }
      const parser = new ObjectPathParser(path);
      return parser.toOptionalChainPath();
    };
    Path2.removeOptionalChainOperator = (path) => {
      if (!path) {
        return "";
      }
      const parser = new ObjectPathParser(path);
      return parser.removeOptionalChainOperator();
    };
    const parsePath = (path) => {
      const result = [];
      const regex = /\.([^.\[]+)|\[(\d+)\]|\[(['"])(.*?)\3\]/g;
      let match;
      let lastIndex = 0;
      const firstMatch = path.match(regex);
      if (firstMatch && (firstMatch?.index ?? 0) > 0) {
        result.push(path.substring(0, firstMatch.index));
        lastIndex = firstMatch.index;
      } else if (!firstMatch && path.length > 0) {
        result.push(path);
        return result;
      }
      while ((match = regex.exec(path)) !== null) {
        if (match.index > lastIndex) {
          const segment = path.substring(lastIndex, match.index);
          if (segment.startsWith(".")) {
            result.push(segment.substring(1));
          } else {
            result.push(segment);
          }
        }
        if (match[1]) {
          result.push(match[1]);
        } else if (match[2]) {
          result.push(parseInt(match[2], 10));
        } else if (match[4]) {
          result.push(match[4]);
        }
        lastIndex = regex.lastIndex;
      }
      if (lastIndex < path.length) {
        const remaining = path.substring(lastIndex);
        if (remaining.startsWith(".")) {
          result.push(remaining.substring(1));
        } else {
          result.push(remaining);
        }
      }
      return result;
    };
    Path2.to = (obj) => {
      const destination = {};
      Object.entries(obj).forEach(([path, value]) => {
        Path2.set(destination, path, value);
      });
      return destination;
    };
    Path2.set = (obj, path, value) => {
      const pathParts = parsePath(path);
      let current = obj;
      for (let i = 0; i < pathParts.length; i++) {
        const part = pathParts[i];
        const isLastPart = i === pathParts.length - 1;
        if (isLastPart) {
          current[part] = value;
        } else {
          const nextPart = pathParts[i + 1];
          if (typeof nextPart === "number") {
            if (!Array.isArray(current[part])) {
              current[part] = [];
            }
            if (Array.isArray(current[part])) {
              while (current[part].length <= nextPart) {
                current[part].push({});
              }
            }
          } else {
            if (typeof current[part] !== "object" || current[part] === null) {
              current[part] = {};
            }
          }
          current = current[part];
        }
      }
    };
    Path2.get = (obj, path, defaultValue) => {
      const pathParts = parsePath(path);
      let current = obj;
      for (let i = 0; i < pathParts.length; i++) {
        const part = pathParts[i];
        if (current === null || current === void 0) {
          return defaultValue;
        }
        if (typeof current === "object" && current !== null && part in current) {
          current = current[part];
        } else {
          return defaultValue;
        }
      }
      return current;
    };
    Path2.deletePath = (obj, path) => {
      const pathParts = parsePath(path);
      if (pathParts.length === 0) {
        return false;
      }
      let current = obj;
      for (let i = 0; i < pathParts.length - 1; i++) {
        const part = pathParts[i];
        if (current === null || current === void 0) {
          return false;
        }
        if (typeof current === "object" && current !== null && part in current) {
          current = current[part];
        } else {
          return false;
        }
      }
      const finalPart = pathParts[pathParts.length - 1];
      if (current !== null && typeof current === "object" && finalPart in current) {
        if (Array.isArray(current) && typeof finalPart === "number") {
          current.splice(finalPart, 1);
        } else {
          delete current[finalPart];
        }
        return true;
      }
      return false;
    };
    Path2.availablePath = (obj, filter) => {
      const paths = [];
      const formatKey = (key) => {
        if (typeof key === "number") {
          return "[" + key + "]";
        }
        if (!/^[a-zA-Z_$][a-zA-Z0-9_$]*$/.test(key)) {
          return "['" + key + "']";
        }
        return key;
      };
      const traverse = (current, currentPath, visited) => {
        if (current === null || typeof current !== "object") {
          return;
        }
        if (visited.has(current)) {
          return;
        }
        visited.add(current);
        if (Array.isArray(current)) {
          current.forEach((item, index) => {
            const formattedIndex = formatKey(index);
            const newPath = currentPath ? `${currentPath}${formattedIndex}` : formattedIndex;
            if (!filter || filter(newPath, item)) {
              paths.push(newPath);
            }
            traverse(item, newPath, visited);
          });
        } else {
          Object.keys(current).forEach((key) => {
            const formattedKey = formatKey(key);
            let newPath;
            if (formattedKey.startsWith("[")) {
              newPath = currentPath ? `${currentPath}${formattedKey}` : formattedKey;
            } else {
              newPath = currentPath ? `${currentPath}.${formattedKey}` : formattedKey;
            }
            if (!filter || filter(newPath, current[key])) {
              paths.push(newPath);
            }
            traverse(current[key], newPath, visited);
          });
        }
      };
      traverse(obj, "", /* @__PURE__ */ new Set());
      return paths;
    };
    Path2.detectPathFromScript = (script, options) => {
      const usingVars = /* @__PURE__ */ new Set();
      class GetDetectProxy {
        constructor(prefix) {
          this.prefix = prefix;
          this.usingVars = usingVars;
        }
        set(target, p, value, receiver) {
          return true;
        }
        get(target, p, receiver) {
          if (typeof p === "symbol") {
            return this.createSafeProxy(this.prefix);
          }
          let items;
          const propStr = String(p);
          if (!isNaN(Number(propStr))) {
            items = this.prefix ? `${this.prefix}[${propStr}]` : propStr;
          } else {
            items = this.prefix ? `${this.prefix}.${propStr}` : propStr;
          }
          if (items) {
            this.usingVars.add(items);
          }
          return this.createSafeProxy(items);
        }
        apply(target, thisArg, argArray) {
          return this.createSafeProxy(this.prefix);
        }
        createSafeProxy(prefix) {
          const dummyFunction = () => {
          };
          const handler = new GetDetectProxy(prefix);
          return new Proxy(dummyFunction, {
            get: (target, prop, receiver) => {
              if (prop === Symbol.toPrimitive) {
                return () => "";
              }
              if (prop === "valueOf") {
                return () => handler.createSafeProxy(prefix);
              }
              if (prop === "toString") {
                return () => "";
              }
              return handler.get(target, prop, receiver);
            },
            set: handler.set.bind(handler),
            apply: handler.apply.bind(handler)
          });
        }
      }
      const globalContext = {
        window: new Proxy(() => {
        }, new GetDetectProxy("window")),
        document: new Proxy(() => {
        }, new GetDetectProxy("document")),
        console: new Proxy(() => {
        }, new GetDetectProxy("console"))
        // this는 destUser 자체가 됨
      };
      const destUser = new Proxy(() => {
      }, new GetDetectProxy("this"));
      try {
        const maskedScript = script.replace(/#([^#]+)#/g, "__DOMRENDER_VAR_$1__");
        const func = new Function("window", "document", "console", `"use strict"; ${maskedScript}; `);
        func.call(destUser, globalContext.window, globalContext.document, globalContext.console);
      } catch (e) {
        console.error("detectPathFromScript error:", script, e);
      }
      if (options?.excludeThis) {
        const filteredVars = /* @__PURE__ */ new Set();
        usingVars.forEach((path) => {
          if (path === "this") {
            return;
          } else if (path.startsWith("this.")) {
            filteredVars.add(path.substring(5));
          } else {
            filteredVars.add(path);
          }
        });
        return filteredVars;
      }
      return usingVars;
    };
  })(Path = ObjectUtils2.Path || (ObjectUtils2.Path = {}));
  ObjectUtils2.toDeleteKey = (obj, keys) => {
    const target = { ...obj };
    ObjectUtils2.deleteKey(target, keys);
    return target;
  };
  ObjectUtils2.deleteKey = (obj, keys) => {
    keys.filter((it) => isDefined(it)).forEach((it) => {
      delete obj[it];
    });
  };
  let Script;
  (function(Script2) {
    Script2.evaluateReturn = (script, thisTarget = {}) => {
      let bodyScript = "";
      let returnScript = "";
      if (typeof script === "object") {
        bodyScript = script.bodyScript;
        returnScript = script.returnScript;
      } else {
        returnScript = script;
      }
      return Script2.evaluate(`${bodyScript}; return ${returnScript} `, thisTarget);
    };
    Script2.evaluate = (script, thisTarget = {}) => {
      try {
        return Function(`"use strict"; ${script} `).bind(thisTarget)();
      } catch (e) {
        console.error("eval error", e);
        console.error(script);
        return void 0;
      }
    };
  })(Script = ObjectUtils2.Script || (ObjectUtils2.Script = {}));
})(ObjectUtils || (ObjectUtils = {}));
export {
  ObjectUtils
};
//# sourceMappingURL=ObjectUtils.js.map
